import React from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { Text } from 'app/src/styles';

import { MERGE_BUYER } from './queries';
import BuyerPicker from './Picker';

const MergeBuyer = ({ buyer, refetch, setShowModal }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      id: buyer.id,
      mergeIntoId: '',
    }
  });

  const [mergeBuyer] = useMutation(MERGE_BUYER, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = input => {
    mergeBuyer({ variables: input });
  };

  return (
    <View>
      <View style={{ gap: 10, marginBottom: 20}}>
        <Text>
          This will merge {buyer.name} into another buyer.
        </Text>
        <Text>
          Records of purchased
          assets, buyer users, offers and bids will all be moved to the selected
          buyer, and this buyer record will be removed.
        </Text>
      </View>
      <BuyerPicker
        name="mergeIntoId"
        label="Merge Into:"
        excludeId={buyer.id}
        control={control}
        errors={errors}
        rules={{required: true}}
      />
      <ButtonContainer>
        <ButtonGroup>
          <Button label="Merge Buyer" onPress={handleSubmit(onSubmit)} />
        </ButtonGroup>
      </ButtonContainer>
    </View>
  );
};

export default MergeBuyer;
